import { render } from "./EditEvent.vue?vue&type=template&id=6a5f3e18&scoped=true"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"

import "./EditEvent.vue?vue&type=style&index=0&id=6a5f3e18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5f3e18"]])

export default __exports__